import { render, staticRenderFns } from "./NormValues.vue?vue&type=template&id=7b827115&scoped=true"
import script from "./NormValues.vue?vue&type=script&lang=js"
export * from "./NormValues.vue?vue&type=script&lang=js"
import style0 from "./NormValues.vue?vue&type=style&index=0&id=7b827115&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b827115",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
